import { render, staticRenderFns } from "./MessageSelectionModal.vue?vue&type=template&id=7baf0e7a&scoped=true"
import script from "./MessageSelectionModal.vue?vue&type=script&lang=js"
export * from "./MessageSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./MessageSelectionModal.vue?vue&type=style&index=0&id=7baf0e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7baf0e7a",
  null
  
)

export default component.exports